import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphText = ({ entity }) => {
  const { t } = useTranslation();
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed'], entity.getIn(['field_text', 0, 'processed']));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], t('general.read_more'));
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));

  return (
    <Container className="Paragraph">
      <div className="row">
        <div className="ParagraphText col-12 col-lg-8 offset-lg-2">
          {title && <h2 className="ParagraphText__title">{title}</h2>}

          {body && (
            <WysiwygField
              property="schema:text"
              className="subheading2"
              html={body}
            />
          )}

          {linkUri && (
            <Button href={linkUri}>
              {linkTitle} <i className="icon icon-arrow-right" />
            </Button>
          )}
        </div>
      </div>
    </Container>

  );
};

export default ParagraphText;
